import { aVirusTotalConfig, mockEnrichmentOperationQuery } from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockEnrichmentOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          virusTotalConfig: aVirusTotalConfig(),
        },
      });
    }
  ),
];
